/* eslint-disable no-shadow */
import React from 'react';
import { View, ScrollView, Animated, Dimensions } from 'react-native';
import {
  InvitationBackground,
  CenteredSpinner,
  Button,
} from '../../components';
import { host } from '../../settings/environment';
import EventDescription from '../Event/EventDescription';
import { useRouteMatch, useHistory } from 'react-router-dom';
import Header from '../../components/Header/Header.web';
import { Helmet } from 'react-helmet';
import dayjs from 'dayjs';

function PublicEvent() {
  const history = useHistory();
  const [event, setEvent] = React.useState(null);
  const [conversation, setConversation] = React.useState(null);
  // eslint-disable-next-line no-unused-vars
  const [scrollY, setScrollY] = React.useState(new Animated.Value(0));
  const match = useRouteMatch();
  const fetchData = async () => {
    const event = await fetch(`${host}/api/public/events/${match.params.id}/`)
      .then(response => response.json())
      .catch(e => console.log(e));
    setEvent(event);
    const conversation = await fetch(
      `${host}/api/public/conversations/${event.conversation}/`,
    )
      .then(response => response.json())
      .catch(e => console.log(e));
    setConversation(conversation);
  };
  React.useEffect(() => {
    fetchData();
  }, []);
  if (!event || !conversation) {
    return <CenteredSpinner />;
  }
  return (
    <View style={{ flex: 1 }}>
      <Helmet>
        <title>
          {`${event.text[0]} am ${dayjs(event.starts_at).format(
            'DD.MM.YYYY',
          )} bei ${event.hosts[0].first_name} - Triff`}
        </title>
        <meta
          name="og:title"
          content={`Bist du dabei? ${event.text[0]} am ${dayjs(
            event.starts_at,
          ).format('DD.MM.YYYY')} bei ${event.hosts[0].first_name} - Triff`}
        />
        <meta
          name="description"
          content={`Bist du dabei? ${event.text[0]} am ${dayjs(
            event.starts_at,
          ).format('DD.MM.YYYY')} bei ${event.hosts[0].first_name} - Triff`}
        />
        <meta name="og:description" content={event.text[1] || ''} />
        <meta
          name="og:image"
          content={event.image || event.hosts[0].image || ''}
        />
      </Helmet>
      <InvitationBackground
        theme={event.theme}
        source={event.image}
        scrollY={scrollY}
      >
        <Header />
        <ScrollView
          onScroll={Animated.event([
            { nativeEvent: { contentOffset: { y: scrollY } } },
          ])}
          contentContainerStyle={{
            minHeight: Dimensions.get('window').height * 1.25,
          }}
          scrollEventThrottle={32}
        >
          <View style={{ flex: 1, padding: 10, justifyContent: 'center' }}>
            <EventDescription isPublicSite event={event} openModal={() => {}} />
          </View>
        </ScrollView>
        <View style={{ padding: 10, paddingTop: 0 }}>
          <Button
            text="Teilnehmen"
            size="large"
            action={() => history.push('/register')}
          />
        </View>
      </InvitationBackground>
    </View>
  );
}

export default PublicEvent;
